import { CommonModule } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { FormGroup, FormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BehaviorSubject, firstValueFrom, Observable, Subject, Subscription } from "rxjs";
import { auditTime, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { CandidateInvitedForJobFilterComponent } from "src/app/components/job-module/candidate-invited-for-job-filter/candidate-invited-for-job-filter.component";
import { JobApplicantFilterComponent } from "src/app/components/job-module/job-applicant-filter/job-applicant-filter.component";
import { JobApplicantsComponent } from "src/app/components/job-module/job-applicants/job-applicants.component";
import { JobFilterTemplateComponent } from "src/app/components/job-module/job-filter-template/job-filter-template.component";
import { JobFilterVerticalTemplateComponent } from "src/app/components/job-module/job-filter-vertical-template/job-filter-vertical-template.component";
import { JobsViewedByComponent } from "src/app/components/job-module/jobs-viewed-by/jobs-viewed-by.component";
import { JobsCandidatesSlideFilterComponent } from "src/app/components/jobs-candidates-slide-filter/jobs-candidates-slide-filter.component";
import { GigsumoConstants, USER_TYPE } from "src/app/services/GigsumoConstants";
import { TourService } from "src/app/services/TourService";
import { ApiService } from "src/app/services/api.service";
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from "src/app/services/gigsumoService";
import { JobService } from "src/app/services/job.service";
import { AppSettings } from "src/app/services/AppSettings";
import { JobModel } from "src/app/services/jobModel";
import { jobModuleConfig } from "src/app/services/jobModuleConfig";
import { PageType } from "src/app/services/pageTypes";
import { SearchData } from "src/app/services/searchData";
import { filterModel } from "src/app/services/userModel";
import { UtilService } from "src/app/services/util.service";
import { CommonSkeletonComponent } from "src/app/skeleton/common-skeleton/common-skeleton.component";
import { filterConfig } from "src/app/types/filterConfig";
import { CommunicationService } from "src/shared/services/CommunicationService";
import { CandiatesInvitedComponent } from "../../../../components/job-module/candiates-invited/candiates-invited.component";
import { JobsComponent } from "../../../../components/job-module/job/job.component";
import { JoblikedListComponent } from "../../../../components/job-module/jobliked-list/jobliked-list.component";
import { ResumeRequestSentComponent } from "../../../../components/job-module/resume-request-sent/resume-request-sent.component";
import { JobPublishtoComponent } from "../../../../components/job-publishto/job-publishto.component";
import { ConnectionTemplateComponent } from "../../../../templates/connection-template/connection-template.component";
import { TimezoneDatePipe } from "../../../../timezone-date.pipe";
import { JobSubmitSkillfilterComponent } from "../../../../widget/job-submit-skillfilter/job-submit-skillfilter.component";
import { MessageWidgetComponent } from "../../../../widget/message-widget/message-widget.component";
// import { WidgetModule } from "`../../../../widget/widget.module";
import { JobPortfolioComponent } from "../job-portfolio/job-portfolio.component";
import { TalentPoolComponent } from "../../../../components/job-module/talent-pool/talent-pool.component";
import { SuggestedCandidatesAiListComponent } from "../../../../components/candidate-module/suggested-candidates-ai-list/suggested-candidates-ai-list.component";
import { SubContractModalComponent } from "../../../../components/shared/sub-contract-modal/sub-contract-modal.component";
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


declare var $: any;
@Component({
  selector: 'app-new-job',
  standalone: true,
  imports: [CommonModule, FormsModule, InfiniteScrollModule,
/* WidgetModule, */ MessageWidgetComponent, CandiatesInvitedComponent,
    ResumeRequestSentComponent, JobSubmitSkillfilterComponent, JobPublishtoComponent,
    JobsComponent, JoblikedListComponent, JobsCandidatesSlideFilterComponent,
    JobFilterVerticalTemplateComponent, JobApplicantFilterComponent, CandidateInvitedForJobFilterComponent,
    JobFilterTemplateComponent, CommonSkeletonComponent, JobPortfolioComponent, JobApplicantsComponent,
    JobsViewedByComponent, TalentPoolComponent, SuggestedCandidatesAiListComponent, ConnectionTemplateComponent, TimezoneDatePipe, BsDropdownModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './new-job.component.html',
  styleUrls: ['./new-job.component.scss']
})
export class NewJobComponent implements OnInit, AfterViewInit, OnDestroy {
  designVersion: string = 'v3';
  url = AppSettings.ServerUrl + "download/";
  filterApplied: boolean = false
  deactivatedJobs: Array<JobModel> = [];
  @Input() filterData: any;
  @Input() focus: string;
  modalRef: BsModalRef
  sendProfileData
  validTotalPoints: boolean;
  totalCount
  listingCount = 0;
  valid: boolean = true;
  freelanceCount = 0;
  event: string = "JOB";
  response = new BehaviorSubject<any>([]);
  searchObserver = new Subject<string>();
  dataPasstoSkillwidgets: Array<any> = [];
  @Input() screenName: any;
  jobsFoundStatus: any = "";
  responseReceived: boolean = false;
  loadAPIcall: boolean = true;
  loadSkeleton = new BehaviorSubject<boolean>(false);
  loadCenterSkeleton = new BehaviorSubject<boolean>(false);
  isScrollTriggerd : boolean = false;
  queryParamValues: any;
  userIdStorage = localStorage.getItem('userId')
  userType: any = localStorage.getItem('userType') // Fixed circular dependency by removing TalentPoolComponent
  highValue2: number;
  filterChanges: any = {};
  owner: boolean = false
  totalmsgcount: Subscription;
  totalmsgcounts: number = 0;
  networkflag: boolean = false;
  /** When a caller routes here with `?source=myJobs` (or a comma-separated
   *  list), these take precedence over the default userType-based source
   *  filters in `updateJobFilterData()`. */
  sourceFilterFromRoute: string[] | null = null;
  entitySent: any = {}
  id: any;
  activeIds = ['1', '2', '3', '4'];
  uniqueColorClasses = [
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color'
  ];
  repetitions = 40;
  showSuggJobsDataServer: any = [];
  closeResult: string;
  messageData: any;
  isActivityWidgetShown: boolean = false;
  messagemodelflag: Boolean = false
  isScrollEnabled: boolean = true;
  showApplicantFilter: boolean = true;
  clientTypeCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Client', selected: false, disable: false },
    // { label: 'Direct Client', selected: false, disable: false },
    // { label: 'Direct Hire', selected: false, disable: false },
    { label: 'Systems Integrator', selected: false, disable: false },
    { label: 'Staffing Agency', selected: false, disable: false },
    { label: 'Prime Vendor', selected: false, disable: false },
    // { label: 'Vendor', selected: false, disable: false },
    // { label: 'Supplier', selected: false, disable: false },

  ];
  statusCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Draft', selected: false, disable: false },
    { label: 'Active', selected: false, disable: false },
    { label: 'On Hold', selected: false, disable: false },
    { label: 'Filled', selected: false, disable: false },
  ];
  workModeCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Onsite', selected: false, disable: false },
    { label: 'Remote', selected: false, disable: false },
    { label: 'Hybrid', selected: false, disable: false },
  ];
  jobclasscificationCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Corp To Corp', selected: false, disable: false },
    { label: 'W2 - Contract', selected: false, disable: false },
    { label: 'W2 - Full Time', selected: false, disable: false },
    { label: 'Part Time', selected: false, disable: false },
    { label: 'Freelance', selected: false, disable: false },
    { label: 'Internship', selected: false, disable: false },
    { label: 'Contract to Hire', selected: false, disable: false },
    { label: 'Direct Hire', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false },
  ];
  noJobFound: boolean = false
  filterOn: boolean = false
  filterCount: number = 0
  typeOfInfiniteScroll: any;
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false
  }
  data1: any = {};
  totalJobsCount: number;
  apiCount: number = 0
  experienceYearsFlag: boolean = false
  a: any;
  feaJ: boolean;
  daysApplied: boolean = false
  yearApplied: boolean = false
  removeTagvalues: any;
  value: number = 0;
  highValue: number = 0;
  options: any = {
    ceil: 20,
    floor: 0
  };
  value1: number = 0;
  highValue1: number = 0;
  options1: any = {
    floor: 0,
    ceil: 99
  };
  jobFilterForm: UntypedFormGroup
  isCollapsed = true;
  img: any;
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    jobPostedBy: localStorage.getItem('userId')
  }
  previousSearchAfterKey = null;
  connectionJobs: boolean = false;
  data: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  ischeckedJobSource: boolean = false
  ischeckedJobSourceAll: boolean = false
  ischeckedClientType: boolean = false
  ischeckedClientTypeAll: boolean = false
  ischeckedStatus: boolean = false
  jobSourceFlag: boolean = false
  clientTypeFlag: boolean = true
  activeStatus: boolean = null;
  statusFlag: boolean = false
  jobClassificationFlag: boolean = false
  workTypeFlag: boolean = false
  locationFlag: boolean = false
  experienceFlag: boolean = false
  ischeckedStatusAll: boolean = false
  creditexpiredflag: boolean = false
  getResume: boolean = false
  ischeckedJobClassification: boolean = false
  ischeckedJobClassificationAll: boolean = false
  ischeckedWorkType: boolean = false
  ischeckedWorkTypeAll: boolean = false
  jobSource: Array<any> = [];
  searchContent: string = null;
  responseReload = new Subject<any>();
  FeaSugg: boolean = false;
  jobSourceSearchRoute = null
  ScreenLoadBool: boolean = false
  subscription: Subscription;
  FilterSubscription: Subscription;
  jobSourceSelectNetRoute: any
  triggerapi = new BehaviorSubject("null")
  candidateFilter: boolean = false
  searchUserType: any
  availablePoints
  creditsConsume: any = 0;
  jobsData: Array<JobModel> = [];
  subsctiption: Subscription;
  isFilterOpen: boolean = false;
  stateListCA: any;
  stateListIN: any;
  stateListAU: any;
  countryList: any = [];
  isMyJobsShowedOnLoad: boolean = false;
  tabName: string;
  filterSubscriber: Subscription;
  panel: string;
  opendsideBar: boolean = false
  isCallFilter: boolean = false
  filterConfig: filterConfig;
  singlejobeView: boolean = false;
  singlejobeViewFromEyeIcon: boolean = false;
  jobModule: jobModuleConfig;
  jobPortfolioModule: jobModuleConfig;
  totalCountJob: number = 0;
  filterPayLoad: filterModel;
  jobId: any;
  candidateIdgetfromIntraction: any;
  fromContent: "SUGGESTED_JOBS" | "FEATURED_JOB" | "JOBS_FROM_CONNECTION" | "JOBS_FROM_PLATFORM" |
    "BUSINESS_JOBS" | "BUSINESS_CONNECTION_JOBS" | "RECRUITER_NETWORK" | "MANAGEMENT_TALENT_ACQUISITION_NETWORK" | "FREELANCE_RECRUITER_NETWORK";
  routingvalue: Subscription;
  jobConnectionSubscription: Subscription;
  inviteRefreshSubscription: Subscription;
  jobcreatReload: Subscription;
  newJobcreated: boolean = false;
  @ViewChild("widgetsticky") menuElement: ElementRef;
  @ViewChild('jobsRef') jobsRef: JobsComponent;
  afterJobCreated: boolean = false;
  artificialAddNeeded: boolean = false;
  createdJobData: any = null;
  artificialInsertTimeout: any = null;
  reloadActivity: boolean = true;
  JOB_STATUS: string = "";
  networkType !: string;
  networkUserType !: string;
  isJobSeekerORBenchSales: boolean = false;
  tourSteps: any[] = [];
  businessNetworkData: any;
  personalNetworks: any;
  publishedByUsers: any;
  businessCustomers: any;
  businessNetworks: any;
  // Explicit Business Network pick (the network chip(s) the user actually selected).
  // businessNetworks carries the ambient FULL list for the directional filter, so the
  // deliberate pick is derived separately from businessNetworkSelectedData and sent as
  // pickedBusinessNetworks. Empty unless the user narrows to specific network(s).
  pickedBusinessNetworks: any = [];
  selectedNetworkId: any;
  workModeData: any;
  businessId: any;
  businessSubscription: Subscription;
  tempPersonalNetworks: any;
  // Track the detail header "More" dropdown state to coordinate with job card dropdowns
  openDetailHeaderDropdown: boolean = false;
  dropdownCoordinatorSubscription: Subscription;
  constructor(
    private apiService: ApiService, private commonvalues: CommonValues, private searchData: SearchData,
    private formBuilder: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private pricePlanService: PricePlanService,
    private pageType: PageType, private modalService: BsModalService, private tourService: TourService,
    private util: UtilService, private jobService: JobService, private communicationService: CommunicationService,
    public gigsumoService: GigsumoService, private cdr: ChangeDetectorRef) {
      this.loadSkeleton.next(true);
      this.loadCenterSkeleton.next(true);
    this.BaseresponseFilter();
    this.stopscrollFlag = false
    this.filterSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      this.panel = value.panel;
      this.opendsideBar = value.value;
      this.entitySent.entity = value.panel;
      if (value.panel == 'jobs') {
        if (value.value == true) {
          this.openFilterSlider();
        } else {
          this.closeFilterSlider();
        }
      }
    });

    // Listen for dropdown state changes from job component to close detail header dropdown
    this.dropdownCoordinatorSubscription = this.searchData.getDropdownState().subscribe(state => {
      if (state.open && (state.type === 'kebab' || state.type === 'status')) {
        this.openDetailHeaderDropdown = false;
        this.cdr.detectChanges();
      }
    });


    this.totalmsgcount =this.commonvalues.getMsgCount().subscribe(count => {
      this.totalmsgcounts = count;
    });


    this.tourService.getTourSteps('JobPage').subscribe(data => {
      this.tourSteps = data;
    });


    this.routingvalue = this.activatedRoute.queryParams.subscribe((res) => {

      // Preselect source filter when caller routes with e.g. `?source=myJobs`
      // (comma-separated list for multiple sources). Consumed below by
      // `updateJobFilterData()`, which runs after the form is built.
      if (res.source) {
        this.sourceFilterFromRoute = String(res.source)
          .split(',')
          .map((s: string) => s.trim())
          .filter((s: string) => !!s);
      }

      // if we want to route from anywhere please use this
      if (res.jobId && res.tabName) {
        this.singlejobeView = true;
        this.jobId = res.jobId;
        this.candidateIdgetfromIntraction = res.candidateId;
        this.tabName = res.tabName;
        if (res.From) {
          this.singlejobeViewFromEyeIcon = true;
          this.fromContent = res.From;
        }
      }
      // after create job this flow will trigger
      else if (res.createJob) {
        this.afterJobCreated = true;
        this.jobId = res.createJob;
        this.JOB_STATUS = res.status;
        this.artificialAddNeeded = res.artificialAdd === 'true';
        this.createdJobData = {
          jobId: res.createJob,
          status: res.status,
          fullJobData: res.jobData ? JSON.parse(res.jobData) : null
        };
      }
      // this flow will work when user route from network Card
      else if (res.networkName) {
        this.networkflag = true;
        this.networkUserType = res.networkName;
        if (res.networkName === 'RECRUITER_NETWORK') {
          this.networkType = "recruiterNetworkJobs"
        } else if (res.networkName === 'MANAGEMENT_TALENT_ACQUISITION_NETWORK') {
          this.networkType = "mtaNetworkJobs"
        } else if (res.networkName === 'FREELANCE_RECRUITER_NETWORK') {
          this.networkType = "freeLancerNetworkJobs"
        } else if (res.networkName === 'JOB_SEEKER_NETWORK' || res.networkName === "BENCH_SALES_NETWORK") {
          this.isJobSeekerORBenchSales = true;
        } else if (res.networkName === 'PERSONAL_NETWORK') {
          this.networkType = res.networkName;
          this.selectedNetworkId = res.networkId;
        }
      }
    });

    this.jobConnectionSubscription = this.commonvalues.getJobData().subscribe(jobObject => {
      this.updateConnectionStatus(jobObject);
    });

    // Apply success — emitted from job-submit-skillfilter.component.ts:413.
    // The card the user just applied from carries a stale `candidatesApplied`
    // array, which gets carried into selectedJobData when they click the
    // Candidate Applied link (new-job.component.ts updateJobDetails / TAB_ROUTE
    // branch). The stale array drives the candidate-applied payload
    // (job-applicants.component.ts:352) and the just-applied candidate is
    // missing from the resulting list. Re-call jobs/filter for that one
    // jobId so the fresh job replaces the stale entry in the list and in
    // selectedJobData (if currently open).
    this.inviteRefreshSubscription = this.commonvalues.getinviterefresh().subscribe((data) => {
      const appliedJobId = data?.jobId;
      if (!appliedJobId) return;
      const refreshPayload = {
        ...this.filterPayLoad,
        source: { ...(this.filterPayLoad?.source || {}), all: true },
        searchContent: appliedJobId,
        searchAfterKey: null
      };
      this.apiService.create(this.API_NAME, refreshPayload).subscribe((res: any) => {
        if (res?.code !== this.SUCCESS_CODE) return;
        const jobList: any[] = res?.data?.jobList || [];
        const freshJob = jobList.find((j: any) => j?.jobId === appliedJobId);
        if (!freshJob) return;
        const list = this.response.getValue() || [];
        const idx = list.findIndex((j: any) => j?.jobId === appliedJobId);
        if (idx !== -1) {
          const next = [...list];
          next[idx] = freshJob;
          this.response.next(next);
        }
        if (this.selectedJobData?.jobId === appliedJobId) {
          this.selectedJobData = { ...freshJob };
        }
      });
    });
  }


  async getBusinessDetails(){
    try {
      const response = await firstValueFrom(this.apiService.query(`business/findUserRoleInBusiness/${localStorage.getItem('userId')}`));
      if(response.code == '00000'){
        const orgId = response.data?.businessData?.organisationId;
        // localStorage.setItem('organisationId',orgId);
        // this.loadTalentPoolData();
      }
      return response;
    } catch (error) {
      return {
        code : "99999"
      }
    }
  }

  loadTalentPoolData() {
    let payload : any = {};
    payload.userId = localStorage.getItem('userId');
    // payload.organisationId = localStorage.getItem('organisationId');
    payload.limit = 10;

    this.responseReceived = false;
    this.loadAPIcall = true;

    console.log('[new jobs] API Call with payload:', payload);

    const sub = this.apiService.create('jobs/triggerMatchInsight', payload).subscribe(
      res => {
        
      },
      err => {
        console.error('[new jobs] API Error:', err);        
      }
    );
  }

  async updateUserBenefits() {
    await this.pricePlanService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    // console.log("PROVIDER_VALUE IS HEREREEEE " , this.countProvider.getBenefits());
  }

  getNetworkUserType(val: string): USER_TYPE {
    if (val) {

      switch (val) {
        case "MANAGEMENT_TALENT_ACQUISITION_NETWORK":
          return GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION;
        case "FREELANCE_RECRUITER_NETWORK":
          return GigsumoConstants.FREELANCE_RECRUITER;
        case "RECRUITER_NETWORK":
          return GigsumoConstants.RECRUITER;
        case "JOB_SEEKER_NETWORK":
          return GigsumoConstants.JOB_SEEKER;
        case "BENCH_SALES_NETWORK":
          return GigsumoConstants.BENCH_RECRUITER;
        default:
          return "RECRUITER";
          break;
      }

    }
  }



  widgetstick: boolean = true
  suggestionStick: boolean = false
  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 35) {
      this.suggestionStick = true;
    } else {
      this.suggestionStick = false;
    }
  }

  updateConnectionStatus(jobData) {
    if(jobData && this.response.getValue().length > 0) {
      const currentJobData = this.response.getValue();
      const updatedJobData = currentJobData.map(job=>
        job.jobPostedBy === jobData.jobPostedBy ? { ...job, connectionStatus: jobData.connectionStatus } : job);
      this.response.next(updatedJobData);
    }
  }


  // Lifecycle hook to load dynamic component after view initialization
  ngAfterViewInit(): void {
    // Trigger initial load of JobProfileDetailComponent if conditions are met
    // Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      if (this.selectedJobData && this.jobDetailsTabName === 'job-details') {
        this.loadJobProfileDetailComponent();
      }
    }, 0);
  }

  // Thiru changed code 02-01-2024
  ngOnDestroy(): void {
    if (this.FilterSubscription != undefined) {
      this.FilterSubscription.unsubscribe();
    }
    if (this.jobcreatReload != undefined) {
      this.jobcreatReload.unsubscribe();
    }
    if (this.totalmsgcount != undefined) {
      this.totalmsgcount.unsubscribe();
    }
    if (this.routingvalue != undefined) {
      this.routingvalue.unsubscribe();
    }
    if(this.jobConnectionSubscription != undefined) {
      this.jobConnectionSubscription.unsubscribe();
    }
    if (this.inviteRefreshSubscription != undefined) {
      this.inviteRefreshSubscription.unsubscribe();
    }
    if(this.businessSubscription){
      this.businessSubscription.unsubscribe();
    }
    if (this.dropdownCoordinatorSubscription != undefined) {
      this.dropdownCoordinatorSubscription.unsubscribe();
    }
    // Clear artificial job insertion timeout
    if (this.artificialInsertTimeout) {
      clearTimeout(this.artificialInsertTimeout);
    }
    // Clean up dynamically loaded component
    if (this.jobProfileDetailComponentRef) {
      this.jobProfileDetailComponentRef.destroy();
      this.jobProfileDetailComponentRef = null;
    }
  }

  diffcolourLabel() {
    let colurclass = [];
    for (let i = 0; i < this.repetitions; i++) {
      colurclass = colurclass.concat(this.uniqueColorClasses);
    }
  }

  keyarrayjobsouces = ["all", "myJobs", "marketPlaceJobs", "teamJobs", "recruiterNetworkJobs", "freeLancerNetworkJobs", "mtaNetworkJobs", "featured", "suggestedJobs"];

  get jobListLabel(): string {
    const activeSources = this.jobSource.filter(s => this.keyarrayjobsouces.includes(s));
    if (activeSources.length === 1 && activeSources[0] === 'myJobs') return 'My Jobs';
    if (activeSources.length > 0) return 'All Jobs';
    return 'Jobs';
  }

  ngOnInit() {

    if (!this.singlejobeViewFromEyeIcon) {
      this.updateUserBenefits();
    }

    this.createjobFilterForm();
    // this.updateJobFilterData(); //these got moved into the above method this.createjobFilterForm, to handle async/await scenario
    // if (!this.singlejobeView) {
    //   this.RoleBasedFilter();
    // } else {
    //   this.singlejobMethod()
    // }

    this.updateJobModule();
    // update filter passing function
    this.updateFilterPassing();
    this.updateJobPortfolioModule();

    // this.loadTalentPoolData();

    // search filter
    this.searchObserver.pipe(
      auditTime(500),
      distinctUntilChanged(),
      debounceTime(1000),
    ).subscribe((res: string) => {
      if (res != "") {
        this.loadCenterSkeleton.next(true);
        this.filterPayLoad.searchContent = res;
        this.filterPayLoad.searchAfterKey = null;
        this.filterPayLoad.jobsToFilter = null;
        this.singlejobeView = false;
        this.afterJobCreated = false;
        this.filterapicall(res);
      }
      else if (res === null) {
        this.loadCenterSkeleton.next(true);
        this.filterPayLoad.searchContent = "";
        this.filterPayLoad.searchAfterKey = null;
        this.filterPayLoad.jobsToFilter = null;
        this.singlejobeView = false;
        this.afterJobCreated = false;
        this.filterapicall();
      }
    });


    this.scrollSubject.pipe(
      debounceTime(100),
    ).subscribe(data => {
      this.filterPayLoad.searchAfterKey = this.previousSearchAfterKey;
      this.filterapicall();
    });

    console.log('[NewJob] ngOnInit - Checking tour status');

    // Check if a tour is currently in progress (user refreshed during tour)
    const isTourInProgress = this.tourService.isTourInProgress('NewJobComponent');
    const tourStarted = localStorage.getItem('tourStarted_NewJobComponent') === 'true';
    console.log('[NewJob] Tour in progress check:', { isTourInProgress, tourStarted });

    if (isTourInProgress || tourStarted) {
      console.log('[NewJob] Tour in progress or started, resuming from last step with delay');
      setTimeout(() => {
        console.log('[NewJob] Executing resumeTour after delay');
        this.resumeTour();
      }, 500);
    }

  }


  resumeTour() {
    console.log('[NewJob] resumeTour - Starting tour resume logic');
    const lastTourStep = localStorage.getItem('lastTourStep_NewJobComponent');
    const tourStarted = localStorage.getItem('tourStarted_NewJobComponent') === 'true';
    const isCompleted = localStorage.getItem('tourCompleted_NewJobComponent') === 'true';

    console.log('[NewJob] resumeTour - localStorage values:', {
      lastTourStep,
      tourStarted,
      isCompleted
    });

    if (isCompleted) {
      console.log('[NewJob] resumeTour — JobPage tour already completed');
      localStorage.setItem(`tourCompleted_${NewJobComponent}`, 'true');
      return;
    }

    // If we have a lastTourStep, use it to resume from that step
    if (lastTourStep) {
      console.log('[NewJob] resumeTour - Resuming from lastTourStep:', lastTourStep);
      this.tourService.resumeTourForComponent('NewJobComponent', 'JobPage');
    } else if (tourStarted) {
      // If tour was started but no lastTourStep (refresh on step 1), start from beginning
      console.log('[NewJob] resumeTour - Tour was started but no lastTourStep, starting tour from step 1');
      this.tourService.startTourForComponent('NewJobComponent', 'JobPage');
    } else {
      console.log('[NewJob] resumeTour - No tour in progress');
    }
  }


  onMouseEnter() {
    const scrollableElement = document.getElementById('widget-flex-item');
    scrollableElement.classList.add('show-scrollbar')
  }

  onMouseLeave() {
    const scrollableElement = document.getElementById('widget-flex-item');
    scrollableElement.classList.remove('show-scrollbar')
  }

  singlejobMethod() {
    this.findByJobId(this.jobId);
  }

  filterReset(data) {
    if (data.pageName == 'job-applicants' || data.pageName == 'candidates-invited' || data.pageName == 'candidate-applied') {
      this.showApplicantFilter = true;
    } else {
      this.showApplicantFilter = false;

    }

  }

  removeCandidate(data) {

    this.candidateIdgetfromIntraction = undefined;
  }

  createjobFilterForm() {
    this.jobFilterForm = this.formBuilder.group({
      source: this.formBuilder.array([
        this.formBuilder.group({
          marketPlaceJobs: false,
          myJobs: false,
          teamJobs: false,
          recruiterNetworkJobs: false,
          freeLancerNetworkJobs: false,
          mtaNetworkJobs: false,
          featured: false,
          suggestedJobs: false,
          businessNetwork: false,
          memberNetworksJobs: false
        })
      ]),
      workMode: [],
      jobClassification: null,
      clientType: null,
      status: null,
      userId: localStorage.getItem('userId'),
      country: null,
      state: null,
      city: null,
      zipCode: null,
      experienceFrom: null,
      experienceTo: null,
      postedFrom: null,
      postedTo: null,
      resetFilter: false,
      postedDayRange: 'Any (Days)',
      experienceType: 'Any (Years)',
      organisationTypeParams: this.formBuilder.group({
        all: false,
        owner: false,
        systemsIntergrator: false,
        primeVendor: false,
        vendorStaffingAgency: false
      })

    })

    this.jobsoucefilterFrom();

  }

  get jobSourcesFormarray() {
    return this.jobFilterForm.get('source') as UntypedFormArray;
  }

  async jobsoucefilterFrom() {
    if (this.networkflag) {
      const jobFilterData: any = await this.gigsumoService.getFilterPayload("JOB", this.userIdStorage);
      if (jobFilterData.code === GigsumoConstants.SUCESSCODE) {
        this.personalNetworks = jobFilterData.data.personalNetworks.map(r => {
          let data = GigsumoService.FILTER_ITEMS("JOB").find(x => x.key === this.networkType);
          if (data) {
            if (data.value === r.networkName) {
              return r.networkId;
            }
            return;
          }
        }).filter((networkId: string) => networkId != undefined);

        if(this.selectedNetworkId!=null){
          this.personalNetworks = [this.selectedNetworkId];
        }

        this.tempPersonalNetworks = this.personalNetworks;

      }
        this.updateJobFilterData();
        this.handlePrerequisites();
    } else {
      // this.jobSourcesFormarray.push(this.jobSourcefields())
      this.updateJobFilterData();
      this.handlePrerequisites();
    }
  }

  async handlePrerequisites() {
    const business : any = await this.getBusinessDetails();

    if(business.code === GigsumoConstants.SUCESSCODE){
        this.businessId = business.data.businessData.businessId;
    }

    if (!this.singlejobeView) {
      this.RoleBasedFilter();
    } else {
      this.singlejobMethod()
    }
  }


  jobSourcefields(): UntypedFormGroup {
    return this.formBuilder.group({
      all: false,
      marketPlaceJobs: false,
      myJobs: false,
      teamJobs: false,
      recruiterNetworkJobs: false,
      freeLancerNetworkJobs: false,
      mtaNetworkJobs: false,
      businessNetwork: false,
      memberNetworksJobs: false
      // featured: false,
      // suggestedJobs: false,
    });
  }

  getOwnerNetwork(userType: USER_TYPE): Array<string> {

    const arr = ['recruiterNetworkJobs', 'freeLancerNetworkJobs',
      "mtaNetworkJobs", "myJobs"];

    if (this.isBenchorJob(userType)) {
      arr.splice(arr.length - 1, 1);
    }

    return arr;
  }


  updateJobFilterData() {
    const userType = localStorage.getItem('userType') as USER_TYPE;

    // Route-provided source filter (e.g. "All jobs →" from Recruiter Dashboard
    // sends `?source=myJobs`) — takes precedence over userType defaults.
    if (this.sourceFilterFromRoute && this.sourceFilterFromRoute.length) {
      this.clearJobSourceControl();
      this.patchJobSourceasArr(this.sourceFilterFromRoute, true);
      this.setDefaultFilter(this.sourceFilterFromRoute, true);
      this.sourceFilterFromRoute = null;  // one-shot — honor subsequent user edits
      return;
    }

    // patching source values when user route from NetWorkCard
    if (this.networkflag) {

      if(this.networkType === "PERSONAL_NETWORK"){
        this.setDefaultFilter("");
        return;
      }

      const reset = this.jobFilterForm.get("resetFilter").value;

      if(!reset){
        this.clearJobSourceControl();
        this.patchJobSourceTrue(this.networkType);
        this.setDefaultFilter("");
        return;
      }

    }

    //  if user routing for single job clear the source
    if (this.singlejobeView) {

      if (this.singlejobeViewFromEyeIcon) {
        let filterName: Array<string> = [];
        this.setDefaultFilter(filterName, true);
        this.searchData.setHighlighter('newJobs');
        return;
      }

    }
    // route based on the userTypes
    else{

      if (this.isMTAorFREEorBENCHandJOB(userType)) {

        // after creating job
        if (this.afterJobCreated) {
          this.afterJobCreated = userType === (GigsumoConstants.BENCH_RECRUITER || GigsumoConstants.JOB_SEEKER) ? false : true;
        }

        if (this.isMTAorFREE(userType)) {
          let arr = this.afterJobCreated ? ["myJobs"] : ["myJobs", "marketPlaceJobs"];
          this.patchJobSourceasArr(arr, true);
          this.setDefaultFilter(arr, true);
        }
        else {
          this.setDefaultFilter("marketPlaceJobs");
        }

      }
      else if (this.isRecruiter(userType)) {

        // only triggered when user route from business jobs
        if (this.fromContent === "BUSINESS_CONNECTION_JOBS" || this.fromContent === "BUSINESS_JOBS") {

          if (this.singlejobeViewFromEyeIcon) {
            let filterName: Array<string> = [];
            this.setDefaultFilter(filterName, true);
            this.searchData.setHighlighter('newJobs');
            return;
          }

        }

        let arr = this.afterJobCreated ? ["myJobs"] : ["myJobs", "marketPlaceJobs"];
        this.patchJobSourceasArr(arr, true);
        this.setDefaultFilter(arr, true);
      }

    }




  }

  updateFilterIfuserFromRouting(): string[] {
    this.clearJobSourceControl();
    switch (this.fromContent) {
      case "SUGGESTED_JOBS":
        this.patchJobSourceTrue('suggestedJobs');
        return ["suggestedJobs"];
      case "FEATURED_JOB":
        this.patchJobSourceTrue('featured');
        return ["featured"];
      case "JOBS_FROM_PLATFORM":
        this.patchJobSourceTrue('marketPlaceJobs');
        return ["featured"];
      case "BUSINESS_CONNECTION_JOBS":
        const arr = ['recruiterNetworkJobs', 'freeLancerNetworkJobs', 'mtaNetworkJobs', 'featured', 'suggestedJobs'];
        this.patchJobSourceasArr(arr, true);
        return arr;
      case "BUSINESS_JOBS":
        this.patchJobSourceTrue('myJobs');
        return ['myJobs']
      case "JOBS_FROM_CONNECTION":
        this.patchJobSourceTrue('recruiterNetworkJobs');
        this.patchJobSourceTrue('freeLancerNetworkJobs');
        this.patchJobSourceTrue('mtaNetworkJobs');
        return ["recruiterNetworkJobs", "freeLancerNetworkJobs", "mtaNetworkJobs"];
      case "RECRUITER_NETWORK":
        this.patchJobSourceTrue('recruiterNetworkJobs');
        return ["recruiterNetworkJobs"];
      case "MANAGEMENT_TALENT_ACQUISITION_NETWORK":
        this.patchJobSourceTrue('mtaNetworkJobs');
        return ["mtaNetworkJobs"];
      case "FREELANCE_RECRUITER_NETWORK":
        this.patchJobSourceTrue('freeLancerNetworkJobs');
        return ["freeLancerNetworkJobs"];
      default:
        break;
    }

  }


  patchJobSourceTrue(key: string) {
    this.getSource().at(0).get(key).patchValue(true);
  }

  patchJobSourceasArr(arr: Array<string>, value: boolean) {
    for (const key of arr) {
      this.getSource().at(0).get(key).patchValue(value);
    }
  }

  patchJobSourceFalse(key: string) {
    this.getSource().at(0).get(key).patchValue(false);
  }

  clearJobSourceControl() {
    Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
    });
  }

  setDefaultFilter(value: string | Array<string>, fromRoute: boolean = false) {
    if (value) {
      const userType = localStorage.getItem('userType') as USER_TYPE;

      const isOwner: boolean = ((fromRoute ? value.includes('myJobs') : value === 'myJobs') ||
        (!fromRoute && value === 'myJobs' && !this.isBenchorJob(userType)));

      if (fromRoute) {
        this.jobSource = value as Array<string>;
      }
      else if (!fromRoute && value) {
        this.getSource().at(0).get(value).patchValue(true);
        this.jobSource.push(value);
      }


      if (this.statusCheckboxes && isOwner) {
        this.statusCheckboxes[(this.JOB_STATUS != 'DRAFTED' ? 2 : 1)].selected = true;
        this.jobSource.push(this.JOB_STATUS != 'DRAFTED' ? 'Active' : "Draft");
      }


      this.tempFilterChanges = {};
      this.tempFilterChanges = {
        formData: this.jobFilterForm.getRawValue(),
        checkedItems: this.jobSource,
        statusCheckedItems: this.statusCheckboxes,
        clientTypeCheckedItems: this.clientTypeCheckboxes,
        jobClassifications: this.jobclasscificationCheckboxes,
        workMode: this.workModeCheckboxes,
        personalNetworks : this.personalNetworks,
      };
      console.log("TEmp dsd" , this.tempFilterChanges);

      this.filterPayLoad.source = this.getSource().at(0).value;
      this.filterPayLoad.status = isOwner ? this.JOB_STATUS != 'DRAFTED' ? ['Active'] : ["Draft"] : [];
      this.filterPayLoad.searchAfterKey = null;
      this.filterPayLoad.personalNetworks = this.personalNetworks;
    }
    else{
      this.statusCheckboxes[2].selected = true;
      this.jobSource.push('Active');

      this.tempFilterChanges = {};
      this.tempFilterChanges = {
        formData: this.jobFilterForm.getRawValue(),
        checkedItems: this.jobSource,
        statusCheckedItems: this.statusCheckboxes,
        clientTypeCheckedItems: this.clientTypeCheckboxes,
        jobClassifications: this.jobclasscificationCheckboxes,
        workMode: this.workModeCheckboxes,
        personalNetworks : this.personalNetworks,
      };

      this.filterPayLoad.source = this.getSource().at(0).value;
      this.filterPayLoad.status = ['Active'];
      this.filterPayLoad.searchAfterKey = null;
      this.filterPayLoad.personalNetworks = this.personalNetworks;

    }

  }

  getSource(): UntypedFormArray {
    return this.jobFilterForm.get('source') as UntypedFormArray;
  }

  isRecruiter(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.RECRUITER);
  }

  isBenchorJob(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.JOB_SEEKER ||
      userType === GigsumoConstants.BENCH_RECRUITER);
  }

  isMTAorFREE(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION ||
      userType === GigsumoConstants.FREELANCE_RECRUITER);
  }

  isMTAorFREEorBENCHandJOB(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION
      || userType === GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.BENCH_RECRUITER
      || userType === GigsumoConstants.JOB_SEEKER);
  }


  RoleBasedFilter() {
    this.diffcolourLabel();
    // console.log("1 job Filter form" , this.jobFilterForm.getRawValue());
    // this.userType = localStorage.getItem('userType');
    // const isRecruiter = this.userType === 'RECRUITER';
    // const isFreelanceOrManagement = this.userType === 'FREELANCE_RECRUITER' || this.userType === 'MANAGEMENT_TALENT_ACQUISITION';
    // if (this.owner && this.isMyJobsShowedOnLoad) {
    //   this.updateJobSourceAndFilter('myJobs');
    // } else {
    //   this.updateJobSourceAndFilter('marketPlaceJobs');
    // }

    this.filterapicall();

  }

  checkingnewlyjobcreated() {
    if (this.newJobcreated) {
      this.filterPayLoad.status = ['Active'];
      this.newJobcreated = false;
    }
  }


  findByJobId(jobId: any) {
    this.jobDetailsTabName = this.tabName;
    this.filterapicall();
  }



  prepareFilterPayload() {
    this.filterPayLoad = { ...this.filterPayLoad, searchAfterKey: null };
    // this.response.next([]);
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.stopscrollFlag = false;
    // console.log("after prepearefilter " , this.filterPayLoad);

  }

  updateJobSourceAndFilter(jobSourceType) {
    this.filterPayLoad.source[jobSourceType] = true;
    this.jobSource.push(jobSourceType);
    this.jobSource = [...new Set(this.jobSource)];
  }


  BaseresponseFilter() {
    this.filterPayLoad = {
      "source": {
        "all": false,
        "marketPlaceJobs": false,
        "myJobs": false,
        "teamJobs": false,
        "recruiterNetworkJobs": false,
        "freeLancerNetworkJobs": false,
        "mtaNetworkJobs": false,
        "featured": false,
        "suggestedJobs": false
      },
      "searchAfterKey": null,
     "workMode" : [],
      "experienceFrom": null,
      "experienceTo": null,
      "postedFrom": null,
      "postedTo": null,
      "country": null,
      "state": null,
      "city": null,
      "zipCode": null,
      "limit": 20,
      "userId": localStorage.getItem('userId'),
      "jobClassification": [],
      "clientType": [],
      "status": [],
      "searchContent": "",
      "jobsToFilter": this.jobId,
      "organisationTypeParams": {
        "owner": false,
        "systemsIntergrator": false,
        "vendorStaffingAgency": false,
        "primeVendor": false,
      },
      "personalNetworks": [],
      "businessNetworks": [],
      "customers": [],
      "businessId": ''
    };
  }
  isClicked: boolean = false;
  closeCandidateSupplyModal() {
    this.modalService.hide(1);
    this.isClicked = false;
  }

  InvitetoApplyFilter() {
    if (this.screenName != undefined && this.screenName === 'invite-job-listing') {
      this.BaseresponseFilter();
      for (let key in this.filterPayLoad.source) {
        if (key == 'myJobs') {
          this.filterPayLoad.source.myJobs = true;
          this.filterPayLoad.status = ['Active'];
        } else {
          this.filterPayLoad.source[key] = false;
        }
      }
    }
  }




  API_NAME: string = 'jobs/filter';
  SUCCESS_CODE: string = GigsumoConstants.SUCESSCODE;
  filterapicall(searchContent: string = null) {
    this.loadSkeleton.next(true);
    // On the invite page the list items are hidden while loadAPIcall is true and the
    // skeleton shown instead. Setting it true on every paginating scroll blanks the
    // whole list and reappends it — that flash is the "refreshes while scrolling"
    // the user sees. Keep the list visible while paginating (searchAfterKey set);
    // only show the full skeleton on a fresh load. Other screens keep prior behavior.
    const paginatingInvite = this.screenName === 'invite-job-listing'
      && this.filterPayLoad?.searchAfterKey != null;
    this.loadAPIcall = !paginatingInvite;
    this.filterPayLoad.businessId = this.businessId;
    this.checkingnewlyjobcreated();

    if (!this.singlejobeView) {
      // InvitetoApplyFilter() -> BaseresponseFilter() REBUILDS filterPayLoad from
      // scratch with searchAfterKey: null. On a scroll (pagination) the caller has
      // just set searchAfterKey to the next-page cursor, so rebuilding here nulled
      // it and made filterapicall() WIPE the list + scroll to top (the "refreshes
      // while scrolling" / "reloads on select" bug). Preserve the pagination cursor
      // across the rebuild; a genuine fresh load passes null and still wipes.
      const pageCursor = this.filterPayLoad?.searchAfterKey;
      this.InvitetoApplyFilter();
      this.filterPayLoad.searchAfterKey = pageCursor;
    }

    if (this.screenName === "invite-job-listing") {
      this.filterPayLoad.candidateId = this.filterData.candidateId;
    }

    if (this.singlejobeView || this.afterJobCreated) {
      this.filterPayLoad.jobsToFilter = this.jobId;
    }

    this.commonvalues.changeData(true);

    if (this.filterPayLoad.searchAfterKey === null) {
      this.response.next([]);
      const eleme =  document.getElementById('job-body');
      if (eleme) {
        eleme.scrollTo({ top: 0, behavior: "smooth" });
      }
    }

    // Latest call wins. Every entry point into this method (All Filters
    // Apply, the header Reset, a source chip, search, scroll) used to
    // overwrite FilterSubscription while the previous request was still in
    // flight, so a burst of clicks left several jobs/filter calls racing and
    // handleResponse ran for whichever settled last — the list could end up
    // holding a superseded page, or the pagination cursor of a filter the
    // user had already clicked past. Drop the stale request first.
    this.FilterSubscription?.unsubscribe();
    this.FilterSubscription = this.apiService.create(this.API_NAME, this.filterPayLoad ).subscribe(
        res => this.handleResponse(res, searchContent),
        err => this.handleError(err)
      );
  }

  // API success response
  handleResponse(res, searchContent: string) {


    if (res.code === this.SUCCESS_CODE) {

      const jobData = res.data.jobList;
      const currSearchAfterKey = res.data.searchAfterKey;

      if(jobData && (jobData.length === 0 || JSON.stringify(this.previousSearchAfterKey) === JSON.stringify(currSearchAfterKey))){
        this.stopscrollFlag = true;
      }
      this.previousSearchAfterKey = currSearchAfterKey;

      this.loadAPIcall = false;
      this.commonvalues.changeData(false);
      localStorage.setItem('jobForm', JSON.stringify(this.filterPayLoad));
      this.JobsListdata(res.data, searchContent);
    }
  }

  // API error response
  handleError(err) {
    this.util.stopLoader();
    // this.loadAPIcall = false

    this.commonvalues.changeData(false);
    // console.error('Filter API Error:', err);
  }

  filterFuctionCompleted = new Subject<boolean>();
  // Job List datas
  JobsListdata(data, searchContent: string) {

    this.loadSkeleton.next(false);
    this.loadCenterSkeleton.next(false);
    this.isScrollTriggerd = false;
    if (this.jobFilterForm) {
      this.jobFilterForm.get('resetFilter').patchValue(false);
    }
    let content = this.filterPayLoad.searchContent;


    if ((content != null && searchContent != null && (content && content.trim()) === (searchContent && searchContent.trim()) && searchContent.length > 0)) {
      this.stopscrollFlag = false;
      this.response.next([]);
    }


    if (data.jobList.length > 0) {
      const currentData = this.response.getValue();
      const existingJobIds = new Set(currentData.map(job => job.jobId));
      const filteredNewJobs = data.jobList.filter(job => !existingJobIds.has(job.jobId));
      let combinedResponse = [...currentData, ...filteredNewJobs];

      // Handle artificial job insertion for ASYNC mode
      if (this.artificialAddNeeded && this.createdJobData) {
        const jobExists = data.jobList.some(job => job.jobId === this.createdJobData.jobId);
        if (jobExists) {
          // Job found in response, ensure it's at the first position and selected
          const existingJobIndex = combinedResponse.findIndex(job => job.jobId === this.createdJobData.jobId);
          if (existingJobIndex > 0) {
            // Move the job to first position
            const [jobToMove] = combinedResponse.splice(existingJobIndex, 1);
            combinedResponse.unshift(jobToMove);
          }
          this.artificialAddNeeded = false;
        } else if (this.createdJobData.status !== 'DRAFT') {
          // Job not found and not a draft, add artificially immediately
          combinedResponse = this.artificiallyInsertJobInstantly(combinedResponse);
          this.artificialAddNeeded = false;
        }
      }
      this.dataPasstoSkillwidgets.forEach(parent => {
        combinedResponse.forEach((child, i) => {
          if (parent.jobId == child.jobId) {
            combinedResponse[i].isSelected = true;
          }
        });
      });


      this.response.next(combinedResponse);
      if (this.filterPayLoad.searchAfterKey === null && combinedResponse.length > 0) {
        // Always select the first job, which will be the newly created job if artificially inserted
        this.selectedJobData = combinedResponse[0];
        // Preserve a route-provided tab (e.g. ?tabName=job-applicants from the
        // dashboard Spotlight "View all" link). Otherwise default to job-details.
        const keepRouteTab = this.singlejobeView && !!this.tabName && this.tabName !== 'job-details';
        if (!keepRouteTab) this.jobDetailsTabName = "job-details";

        // If this is an artificially added job, ensure it's properly selected
        if (this.artificialAddNeeded && combinedResponse[0].isArtificiallyAdded) {
          this.selectedJobData = combinedResponse[0];
        }

        // Load job profile detail component dynamically after data is set
        setTimeout(() => this.loadJobProfileDetailComponent(), 0);

        if (this.selectedJobData && !this.selectedJobData.isViewed && this.selectedJobData.jobPostedBy != this.userIdStorage) {
          console.log("Selected job data is ", this.selectedJobData);
          this.jobService.updateJobViewed({
            jobId: this.selectedJobData.jobId,
            jobPostedBy: this.userIdStorage
          }).subscribe(res => {
            if (res.code === GigsumoConstants.SUCESSCODE) {
              this.selectedJobData.isViewed = true;
            }
          });
        }
      }
    }
    
    // Handle case where API returns no jobs but we need to insert artificially
    if (data.jobList.length === 0 && this.artificialAddNeeded && this.createdJobData && this.createdJobData.status !== 'DRAFT') {
      let combinedResponse = [...this.response.getValue()];
      combinedResponse = this.artificiallyInsertJobInstantly(combinedResponse);
      this.artificialAddNeeded = false;
      
      // Update the response and set selection
      this.response.next(combinedResponse);
      if (combinedResponse.length > 0) {
        this.selectedJobData = combinedResponse[0];
        // Preserve route-provided tab — see handleResponse for full rationale.
        const keepRouteTab = this.singlejobeView && !!this.tabName && this.tabName !== 'job-details';
        if (!keepRouteTab) this.jobDetailsTabName = "job-details";

        // Load job profile detail component dynamically after data is set
        setTimeout(() => this.loadJobProfileDetailComponent(), 0);
      }
    }

    if (this.response.getValue().length == 0) {
      this.totalCountJob = 0;
      this.CandidateAcvityData = null;
      this.selectedJobData = null;
      this.jobsFoundStatus = "Couldn't find any jobs for the applied filters.";
    }
    if (data.totalJobsCount !== undefined || data.totalJobsCount === 0) {
      this.totalCountJob = data.totalJobsCount;
    }
  }



  // Label msg set .
  checkForEmptyJobList(jobList, searchAfterKey) {
    if (jobList && (jobList.length === 0 || jobList.length < 10)) {
      this.stopscrollFlag = true;
      this.jobsFoundStatus = "Couldn't find any jobs for the applied filters.";
    } else {
      // this.jobsFoundStatus = "Fetching Jobs...";
      // this.jobsFoundStatus =
      this.stopscrollFlag = false;
      this.checkSearchAfterKey(searchAfterKey);
    }
  }

  checkSearchAfterKey(searchAfterKey) {
    if (searchAfterKey && searchAfterKey[1] != null) {
      this.previousSearchAfterKey = searchAfterKey[1];
      if (searchAfterKey[1] < 0) {
        this.stopscrollFlag = true;
      }
    }
  }



  // when user close or apply the filter from vertical filter this will get triggered
  onFilterToggle(value: any) {
    this.filterApplied = false;
    this.stopscrollFlag = false;
    if (this.panel === 'jobs') {
      if (value === "reset") {
        this.resetFilternew();
        // Trigger change detection to update filter count badge
        this.cdr.detectChanges();
        return;
      }

      // console.log("data from vertical filter  " , value);

      // const receivedData = JSON.parse(value);
      //  this.filterPayLoad = receivedData.jobForm;
      // this.filterPayLoad = receivedData.jobForm;
      this.afterFilterPrepareForm();
      // Trigger change detection to update filter count badge
      this.cdr.detectChanges();
    } else if (this.panel == 'job applicants') {
      this.jobService.setSliderToggle(false, this.panel, value,false);
    } else if (this.panel == 'candidates invited') {
      this.jobService.setSliderToggle(false, this.panel, value,false);
    }
  }

  // Sidebar filter API call
  afterFilterPrepareForm() {
    this.ScreenLoadBool = true;
    const { formData: { source, ...rest } } = this.tempFilterChanges;
    this.filterPayLoad = {
      searchContent: this.filterPayLoad.searchContent,
      ...rest,
      source: source[0],
    }
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.stopscrollFlag = false;
    this.loadCenterSkeleton.next(true);
    this.filterPayLoad.limit = 20;
    this.filterPayLoad.userId = localStorage.getItem('userId');
    this.filterPayLoad.workMode = Array.isArray(this.workModeData)
    ? this.workModeData.filter(element => element.selected).map(element => element.label)
    : [];
    this.filterPayLoad.jobClassification = this.jobclasscificationCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.clientType = this.clientTypeCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.personalNetworks = this.personalNetworks;
    this.filterPayLoad.businessNetworks = this.businessNetworks;
    this.filterPayLoad.pickedBusinessNetworks = this.pickedBusinessNetworks;
    this.filterPayLoad.customers = this.businessCustomers;
    this.filterPayLoad.publishedBy = this.publishedByUsers;
    this.filterapicall();
  }

  initializePayload(data) {
    this.filterPayLoad = { ...data, searchAfterKey: null };
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.stopscrollFlag = false;
  }

  updateCheckboxes(data, key, checkboxes) {
    data[key].forEach(res => {
      checkboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res);
        }
      });
    });
  }

  // updateSourceWorkType(data, type) {
  //   if (type == 'source') {
  //     for (let key in data) {
  //       if (key != "all" && data[key] == true) {
  //         this.jobSource.push(key);
  //       }
  //     }
  //   } else if (type == 'workType') {
  //     for (let key in data) {
  //       if (key != "all" && data[key] === true) {
  //         this.jobSource.push(key);
  //       }
  //     }
  //   }
  // }


  resetFilternew() {
    this.clearCreateJobRouteValue();
    this.loadCenterSkeleton.next(true);
    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;
    this.previousSearchAfterKey = null;
    this.filterPayLoad.searchAfterKey = null;
    this.jobSource = [];
    this.jobFilterForm.reset();
    this.jobFilterForm.get("resetFilter").patchValue(true);
    this.jobFilterForm.get('experienceType').patchValue('Any (Years)');
    this.jobFilterForm.get('postedDayRange').patchValue('Any (Days)');
    this.statusCheckboxes = this.resetStatusCheckBox();
    this.workModeCheckboxes= this.resetworkModeCheckBox();
    this.clientTypeCheckboxes = this.resetClientTypeCheckBox();
    this.jobclasscificationCheckboxes = this.resetEngagementTypeCheckBox();
    this.personalNetworks = [];
    this.businessCustomers = [];
    this.publishedByUsers = [];
    this.businessNetworks = [];
    this.pickedBusinessNetworks = [];
    this.BaseresponseFilter()
    this.updateJobFilterData();
    this.filterapicall();
    this.clearFilterselectedcount();
    // Trigger change detection to update filter count badge
    this.cdr.detectChanges();
  }

  clearCreateJobRouteValue(){
    this.singlejobeView = false;
    this.afterJobCreated = false;
    this.networkflag = false;
    this.singlejobeViewFromEyeIcon = false;
    this.fromContent = null;
    this.jobId = null;
    this.JOB_STATUS = "Active";
    // Clear artificial add logic
    clearTimeout(this.artificialInsertTimeout);
    this.artificialAddNeeded = false;
    this.createdJobData = null;
    this.artificialInsertTimeout = null;
  }

  artificiallyInsertJobInstantly(combinedResponse: any[]) {
    if (!this.createdJobData || this.createdJobData.status === 'DRAFT' || !this.createdJobData.fullJobData) {
      return combinedResponse;
    }

    // Check if job doesn't already exist (avoid duplicates)
    const jobExists = combinedResponse.some(job => job.jobId === this.createdJobData.jobId);
    
    if (!jobExists) {
      // Get current user's profile data from localStorage
      const userId = localStorage.getItem('userId');
      const userName = localStorage.getItem('userName');
      const profilePhoto = localStorage.getItem('profilePhoto');
      const userType = localStorage.getItem('userType');
      const currentOrganization = localStorage.getItem('currentOrganization');
      const busLogo = localStorage.getItem('busLogo');
      
      // Use the actual job data from the API response and add missing user profile data
      const artificialJob = {
        ...this.createdJobData.fullJobData,
        isArtificiallyAdded: true,
        jobPostedBehalfOf: currentOrganization || this.createdJobData.fullJobData.jobPostedBehalfOf,
        user: {
          userId: userId,
          fullname: userName,
          photo: profilePhoto && profilePhoto !== 'null' ? profilePhoto : undefined,
          userType: userType,
          workExperience: [{
            organisationName: currentOrganization,
            businessLogo: busLogo && busLogo !== 'null' ? busLogo : undefined,
            currentOrganization: true
          }],
          ...this.createdJobData.fullJobData.user // Keep any existing user data from API
        }
      };
      
      // Insert actual job data at the beginning (index 0)
      combinedResponse.unshift(artificialJob);
    }

    return combinedResponse;
  }

  artificiallyInsertJob() {
    if (!this.createdJobData || this.createdJobData.status === 'DRAFT' || !this.createdJobData.fullJobData) {
      return;
    }

    const currentData = this.response.getValue();
    // Check if job doesn't already exist (avoid duplicates)
    const jobExists = currentData.some(job => job.jobId === this.createdJobData.jobId);
    
    if (!jobExists) {
      // Get current user's profile data from localStorage
      const userId = localStorage.getItem('userId');
      const userName = localStorage.getItem('userName');
      const profilePhoto = localStorage.getItem('profilePhoto');
      const userType = localStorage.getItem('userType');
      const currentOrganization = localStorage.getItem('currentOrganization');
      const busLogo = localStorage.getItem('busLogo');
      
      // Use the actual job data from the API response and add missing user profile data
      const artificialJob = {
        ...this.createdJobData.fullJobData,
        isArtificiallyAdded: true,
        jobPostedBehalfOf: currentOrganization || this.createdJobData.fullJobData.jobPostedBehalfOf,
        user: {
          userId: userId,
          fullname: userName,
          photo: profilePhoto && profilePhoto !== 'null' ? profilePhoto : undefined,
          userType: userType,
          workExperience: [{
            organisationName: currentOrganization,
            businessLogo: busLogo && busLogo !== 'null' ? busLogo : undefined,
            currentOrganization: true
          }],
          ...this.createdJobData.fullJobData.user // Keep any existing user data from API
        }
      };
      
      // Insert actual job data at the beginning (index 0)
      const updatedData = [artificialJob, ...currentData];
      this.response.next(updatedData);
    }

    // Clean up
    this.artificialAddNeeded = false;
    this.artificialInsertTimeout = null;
  }

  clearFilterselectedcount() {
    this.communicationService.triggerMethod('jobs');
  }

  resetStatusCheckBox(): Array<any> {
    return this.statusCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }
  resetworkModeCheckBox(): Array<any> {
    return this.workModeCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }

  resetClientTypeCheckBox(): Array<any> {
    return this.clientTypeCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }

  resetEngagementTypeCheckBox(): Array<any> {
    return this.jobclasscificationCheckboxes.map((val: any) => {
      val.selected = false
      return val;
    });
  }



  cleanJobSource() {
    this.jobSource = [...new Set(this.jobSource)].filter((ele: any) => ele.toLowerCase() !== 'all');
  }

  updateExperienceValues(data) {
    this.value = data.experienceFrom != null ? data.experienceFrom : 0;
    this.highValue = data.experienceTo != null ? data.experienceTo : 0;
    this.value1 = data.postedFrom != null ? data.postedFrom : 0;
    this.highValue1 = data.postedTo != null ? data.postedTo : 0;
  }

  resetFilterPayload(data) {
    this.filterPayLoad = data;
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.stopscrollFlag = false;
  }


  // Remove selected filter

  removeEntity(value, index) {
    this.jobSource.splice(index, 1);

    Object.keys(this.filterPayLoad.source).forEach((key: any) => {
      if (key === value) {
        this.filterPayLoad.source[key] = false;
      }
      if (this.jobSource.includes(key)) {
        this.filterPayLoad.source[key] = true;
      }
    });

    this.clientTypeCheckboxes.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.clientTypeCheckboxes[0].selected = false
      }
    });

    this.statusCheckboxes.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.statusCheckboxes[0].selected = false
      }
    });

    this.jobclasscificationCheckboxes.forEach(element => {
      if (element.selected && element.label == value) {
        element.selected = false;
        this.jobclasscificationCheckboxes[0].selected = false
      }
    });

    this.filterPayLoad.jobClassification = this.jobclasscificationCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.clientType = this.clientTypeCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);

    this.filterPayLoad.searchAfterKey = null;
    this.stopscrollFlag = false;

    let deletingData: any = {}
    deletingData.value = value;
    deletingData.index = index;
    this.jobService.setDataForFilter(deletingData);
    this.filterapicall();
  }


  stopscrollFlag: boolean = false
  scrollSubject = new Subject();
  @ViewChild('inviteScrollContainer') inviteScrollContainer: ElementRef;
  onScrollDown() {
    // Invite page only: selecting a job re-renders this list, so ngx-infinite-scroll
    // re-emits (scrolled) even though the user never scrolled — that paginated on
    // every selection (the "reloads when selecting jobs" bug). Gate on the invite
    // container's REAL position (via #ref — there are two .xs-body-container
    // elements, so querySelector read the wrong one) and only continue when the
    // user is genuinely near the bottom. A mid-list selection-reflow is far from the
    // bottom and is ignored. The normal jobs page is left untouched below.
    if (this.screenName === 'invite-job-listing') {
      const el: any = this.inviteScrollContainer?.nativeElement;
      if (!el) { return; }
      const distanceFromBottom = el.scrollHeight - el.clientHeight - el.scrollTop;
      if (distanceFromBottom > 40) { return; }
    }
    // Never paginate with a null/empty key: the scroll subscription copies
    // previousSearchAfterKey into filterPayLoad.searchAfterKey, and a null there
    // makes filterapicall() WIPE the list and scroll to top (the "refreshes while
    // scrolling" bug at the end of the results).
    const key = this.previousSearchAfterKey;
    const hasKey = !(key === null || key === undefined
      || (Array.isArray(key) && key.length === 0));
    if (hasKey && !this.loadCenterSkeleton.getValue() && !this.stopscrollFlag
        && this.filterPayLoad.searchAfterKey != this.previousSearchAfterKey) {
      this.scrollSubject.next("");
    }
  }


  CandidateAcvityData: any = {
    call: false
  };

  updatetocandidateActivity(data) {
    data.refereshDatas = new Date();
    data.call = true;

    if(data.checked != null){
      data.call = data.checked;
      data.data = [];
    }

    this.CandidateAcvityData = data;
    if (!data.isSelected) {
      this.CandidateAcvityData = { ...this.CandidateAcvityData };
    }

  }

  getchildData(data) {
    if (data != null) {
      this.dataPasstoSkillwidgets = JSON.parse(data);
    } else {
      this.dataPasstoSkillwidgets = [];

    }
  }

  removeUserfromTag(data) {



    if (data === "CLEAR") {
      this.dataPasstoSkillwidgets = [];
      return;
    }

    this.removeTagvalues = data;
    const responseData: Array<any> = this.response.getValue();

    responseData.forEach(element => {
      if (element.jobId == data.jobId) {
        element.isSelected = false;
      }
    });

    this.response.next(responseData);

    this.dataPasstoSkillwidgets.forEach(element => {
      if (element.jobId == data.jobId) {
        element.isSelected = false;
      }
    });
  }

  reloadJobData(value: string) {
    this.reloadProcess(value);
  }


  reloadProcess(data: any) {

    this.loadCenterSkeleton.next(true);
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    if(data === 'discard'){
      this.filterPayLoad.jobsToFilter = null;
      this.singlejobeView = false;
      this.afterJobCreated =  false;
    }
    else{
      this.filterPayLoad.jobsToFilter = data.jobId;
    }

    if (data.value === 'updateReload') {
      this.filterPayLoad.status = ['Active'];
      this.statusCheckboxes.forEach(val => val.selected = false);
      this.statusCheckboxes.find(val => val.label === "Active").selected = true;;
      // update only the status without affecting the existing changes
      this.tempFilterChanges = {
        ...this.tempFilterChanges,
        statusCheckedItems: this.statusCheckboxes,
      }
    }

    this.filterapicall();
  }


  emitReceived(value: any) {
    const currentData = this.response.getValue();
    if (value.jobId == currentData.jobId) {
      currentData[value.index] = { ...currentData[value.index], status: currentData.status }
    }
  }

  getdatafromjob(data: any) {
    data.userId = localStorage.getItem('userId')
    data.pageNumber = 0;
    data.limit = 10;
    this.apiService.create("candidates/findSuggestedCandidates", data).subscribe((res) => {
      res.componentName = 'SuggestedCandidateComponent';
      this.showSuggJobsDataServer = res;
      this.pageType.setsuggjob(res)
    })
  }


  getPanelValue(value: any) {
    this.panel = value;
  }

  searchfilter(val: string) {
    this.searchObserver.next(val === "" ? null : val);
    this.stopscrollFlag = false;
  }


  get searchApiCall(): Observable<any> {
    return this.searchObserver.asObservable();
  }


  // prasanaa  changed code
  jobDetailsTabName: string = "job-details";
  selectedJobData: JobModel;
  selectedJobData_fromView: JobModel;

  // Dynamic component loading to break circular dependency
  @ViewChild('jobProfileDetailContainer', { read: ViewContainerRef }) jobProfileDetailContainer!: ViewContainerRef;
  private jobProfileDetailComponentRef: ComponentRef<any> | null = null;
  updateJobModule() {

    let module = new jobModuleConfig(this.updateJobDetails);
    module.tabName = "job-details";
    module.source = this;
    this.jobModule = module;
  }

  updateJobDetails(data: any, content: any) {
    if (content.for === "JOB_DETAIL") {
      this.selectedJobData = { ...data };
      this.selectedJobData.call = false;
      this.jobDetailsTabName = "job-details";
      // Switching to a different job must reset the details scroll viewport —
      // the shared `.jc-v3-entity-details-body` container sits outside the
      // per-job render so its scrollTop persists across job swaps otherwise.
      // Mirror of the candidate side (new-candidate CANDIDATE_DETAIL branch).
      if (this.designVersion === 'v3') {
        setTimeout(() => {
          const el = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
          if (el) el.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
      }
    }
    else if (content.for === "TAB_ROUTE") {
      this.jobDetailsTabName = data;
      let datas = content.value;
      if (this.isParenActivity(data)) {
        datas.call = true;
      } else {
        datas.call = false;
      }
      this.selectedJobData = { ...datas };
      // Card stat shortcuts (views / likes / applicants count) land here with
      // a DIFFERENT job but the same tab, so the tab component stays mounted
      // and only refills. The shared `.jc-v3-entity-details-body` keeps its
      // old scrollTop, and while the new rows load the browser keeps
      // adjusting the offset (clamp on the skeleton, then scroll anchoring
      // on the rows) — a smooth scroll started here gets cancelled by those
      // adjustments and never reaches 0. Jump instantly instead: there is no
      // old content to animate away from, and 0 is stable across the reload.
      if (this.designVersion === 'v3') {
        setTimeout(() => {
          const el = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
          if (el) el.scrollTop = 0;
        }, 0);
      }
    }
    // Load job profile detail component dynamically when needed
    this.loadJobProfileDetailComponent();
  }


  isParenActivity(data: string): boolean {
    return data === 'job-applicants' || data === 'candidate-applied' || data === 'candidates-invited'
  }

  updateJobPortfolioModule() {
    let module = new jobModuleConfig(this.updateJobPortfolioDetails);
    module.tabName = "job-details";
    module.source = this;
    this.jobPortfolioModule = module;
  }

  private userTypeMap: { [key: string]: string } = {
    'FREELANCE_RECRUITER': 'Freelance Recruiter',
    'RECRUITER': 'Recruiter',
    'JOB_SEEKER': 'Job Seeker',
    'MANAGEMENT_TALENT_ACQUISITION': 'Manager',
    'MANAGEMENT TALENT ACQUISITION': 'Manager',
    'BENCH_RECRUITER': 'Bench Recruiter'
  };

  formatUserType(userType: string): string {
    if (!userType) return '';
    return this.userTypeMap[userType] || userType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  // True only when the detail header's company block would actually show
  // something — a business logo, or a workExperience entry the name loop
  // renders (currentOrganization, or matching jobPostedBehalfOf). FR users
  // with no organization otherwise got a bare briefcase icon + star.
  hasJobOrgHeader(): boolean {
    const job: any = this.selectedJobData || {};
    const wxp: any[] = job.user?.workExperience || [];
    if (this.getJobBusinessLogo()) { return true; }
    return wxp.some(exp => exp?.currentOrganization ||
      (job.jobPostedBehalfOf && job.jobPostedBehalfOf === exp?.organisationName));
  }

  // Logo of the business the job belongs to, taken from the poster's
  // workExperience entry for that business — not workExperience[0], which
  // may be an older company with no logo. The first tier that matches any
  // entry decides; null keeps the briefcase placeholder.
  getJobBusinessLogo(): string | null {
    const job: any = this.selectedJobData || {};
    // jobs/filter resolves the logo from the business index; prefer it.
    if (job.businessLogo && job.businessLogo !== 'null') {
      return job.businessLogo.startsWith('http') ? job.businessLogo : this.url + job.businessLogo;
    }
    const wxp: any[] = job.user?.workExperience || [];
    const behalfOf = (job.jobPostedBehalfOf || '').trim().toLowerCase();
    const tiers: Array<(exp: any) => boolean> = [
      exp => !!job.businessId && exp?.businessId === job.businessId,
      exp => !!job.organisationId && exp?.organisationId === job.organisationId,
      exp => !!behalfOf && (exp?.organisationName || '').trim().toLowerCase() === behalfOf,
      exp => !!exp?.currentOrganization
    ];
    for (const matches of tiers) {
      const hits = wxp.filter(matches);
      if (hits.length) {
        const logo = hits.find(exp => exp?.businessLogo && exp.businessLogo !== 'null')?.businessLogo;
        return logo ? (logo.startsWith('http') ? logo : this.url + logo) : null;
      }
    }
    return null;
  }

  // Delegates to the shared pastel-hash helper so the V3 detail header avatar
  // matches the left-panel card avatars driven by getColor() in job.component.
  getAvatarColor(name: string): string {
    return this.jobService.getColor(name);
  }

  // Throttle guard for the status toggle — ports V2's `toggleOpen` flag
  // (job-profile-detail.component.html:95). Blocks rapid re-clicks while
  // a status-change request is in flight. `enableJob` is fire-and-forget
  // (no observable exposed), so we reset on a short timer instead of
  // waiting for completion. 1500ms covers typical PUT /jobs/updateJob
  // round-trip on QA network.
  toggleOpen: boolean = false;

  // Enable/disable toggle in the V3 detail header — ports the V2 toggle at
  // job-profile-detail.component.html:194-202. Delegates to JobsComponent.enableJob()
  // (via the #jobsRef ViewChild), which owns the plan-check + PUT /jobs/updateJob call.
  async toggleSelectedJob(event: any) {
    if (!this.jobsRef || !this.selectedJobData || this.toggleOpen) return;
    const checkbox = event?.target;
    const newStatus = checkbox?.checked ? 'ACTIVE' : 'ON HOLD';

    // CRITICAL FIX: Reset checkbox to match actual job status immediately.
    // This prevents the checkbox from being out of sync if enableJob shows
    // a popup (e.g., plan exhausted) and doesn't actually change the status.
    // If the status change succeeds, Angular's [checked] binding will update
    // the checkbox when selectedJobData.status changes.
    if (checkbox) {
      checkbox.checked = this.selectedJobData?.status === 'ACTIVE';
    }

    this.toggleOpen = true;
    const proceeded = await this.jobsRef.enableJob(newStatus, this.selectedJobData);
    // If the plan check blocked activation (exhaust popup), the status is
    // unchanged — revert the native checkbox to the real status. Angular won't
    // re-assert an unchanged [checked] binding (false → false), so without this
    // the toggle stays visually ON while the job is still ON HOLD, and the NEXT
    // click fires a spurious ON HOLD update (mirrors enableCandidate's reset).
    if (!proceeded && event?.target) {
      event.target.checked = this.selectedJobData?.status === 'ACTIVE';
    }
    setTimeout(() => { this.toggleOpen = false; }, 1500);
  }

  /** Remaining days of an active featured/upgrade window. Delegates to
   *  `JobsComponent.getActiveUrgencyDays()` (job.component.ts:1355) so
   *  the V3 detail header and V3 small card share one implementation. */
  getActiveUrgencyDays(job: any): number | null {
    return this.jobsRef ? this.jobsRef.getActiveUrgencyDays(job) : null;
  }

  // Same-hue dark text matching the getColor() bg — readable on pastel.
  getAvatarTextColor(name: string): string {
    return this.jobService.getFullnameTextColor(name);
  }

  // Normalizes the photo URL — passes through full http(s) URLs, otherwise
  // prefixes the base photo URL. Mirrors job.component.ts getPhotoUrl().
  getAvatarPhotoUrl(photo: string): string {
    if (!photo) return '';
    if (photo.startsWith('http://') || photo.startsWith('https://')) return photo;
    return this.url + photo;
  }

  // V3 detail header action wrappers — delegate to the JobsComponent instance in the left panel
  applySelectedJob() {
    if (this.jobsRef && this.selectedJobData) {
      this.jobsRef.apply(this.selectedJobData, undefined, this.jobsRef.candidateSupplyTemplate);
    }
  }

  editSelectedJob() {
    if (this.jobsRef && this.selectedJobData) {
      this.jobsRef.editJob(this.selectedJobData);
    }
  }

  republishSelectedJob() {
    if (this.jobsRef && this.selectedJobData) {
      this.jobsRef.republishJob(this.selectedJobData);
    }
  }

  upgradeSelectedJob() {
    if (this.jobsRef && this.selectedJobData) {
      this.jobsRef.featurejobvalues(this.selectedJobData);
    }
  }

  downgradeSelectedJob() {
    if (this.jobsRef && this.selectedJobData) {
      this.jobsRef.downgradeJob(this.selectedJobData);
    }
  }

  // Handle detail header "More" dropdown toggle to coordinate with job card dropdowns
  onDetailHeaderDropdownToggle(open: boolean) {
    this.openDetailHeaderDropdown = open;
    if (open) {
      // Notify job component to close its dropdowns
      this.searchData.setDropdownState('detail-header', true);
    } else {
      this.searchData.setDropdownState('detail-header', false);
    }
    this.cdr.detectChanges();
  }

  // Sub-Contract support for V3 detail header — ported from
  // job-profile-detail.component.ts (getters + openSubContractModal).
  get showSubContractButton(): boolean {
    const myBusinessId = localStorage.getItem('myBusinessId');
    if (!this.selectedJobData?.tierPayRates?.length || !myBusinessId) return false;
    return this.selectedJobData.tierPayRates.some(
      (tier: any) => tier.supplierBusinessId === myBusinessId && tier.subContracted === true
    );
  }

  get subContractedByName(): string | null {
    const tiers = this.selectedJobData?.tierPayRates;
    if (!tiers?.length) return null;
    for (const t of tiers) {
      if (t?.subContractedByBusinessName) return t.subContractedByBusinessName;
    }
    return null;
  }

  openSubContractModal(): void {
    if (!this.selectedJobData) return;
    this.modalService.show(SubContractModalComponent, {
      initialState: {
        jobDetails: this.selectedJobData,
        businessId: localStorage.getItem('businessId'),
        userId: localStorage.getItem('userId')
      },
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    });
  }

  onStatuChange(value: any) {
    if (value && value.content === "STATUS_UPDATED" && value.data) {
      this.selectedJobData = { ...value.data };

      const currentData = this.response.getValue();
      if (Array.isArray(currentData) && currentData.length > 0) {
        const updatedData = currentData.map((job: any) => {
          if (job.jobId === value.data.jobId) {
            return { ...job, ...value.data };
          }
          return job;
        });
        this.response.next(updatedData);
      }
      return;
    }
    this.reloadProcess(value);
  }

  onStatusChangeEvent(jobAndStatus: any) {
    if(jobAndStatus) {
          this.stopscrollFlag = false;
      // Show the list/detail skeleton during the post-status-change reload.
      // Every other reload path (reloadJobData, filter apply, initial load)
      // raises loadCenterSkeleton before filterapicall(); this one didn't, so
      // the reload ran with a blank list and no skeleton.
      this.loadCenterSkeleton.next(true);
      this.filterPayLoad = {
        ...this.filterPayLoad,
        searchAfterKey: null,
        // status: status
      }
      this.filterapicall();
    }
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  sortDateByNormalJobs(val: any) {
    let sortedDate = val.sort((a, b) => { return <any>new Date(b.updatedOn) - <any>new Date(a.updatedOn); })
    this.response.next(this.sortFeature(sortedDate));
  }

  sortFeature(data) {
    return data.sort((a, b) => {
      return b.isFeatured - a.isFeatured;
    });
  }

  // Debounce rapid same-tab re-clicks (double-click). Re-minting selectedJobData
  // twice in quick succession re-triggered the mounted tab child's ngOnChanges
  // twice, firing two racing list loads that corrupted the pagination cursor and
  // stopped infinite scroll. A deliberate re-click (after the ~500ms double-click
  // window) still reloads + scrolls to top as before.
  private lastTabClickName = '';
  private lastTabClickAt = 0;

  updateJobPortfolioDetails(data: string) {
    const now = Date.now();
    if (data === this.lastTabClickName && (now - this.lastTabClickAt) < 500) {
      return;
    }
    this.lastTabClickName = data;
    this.lastTabClickAt = now;
    this.jobDetailsTabName = data;
    if (!this.isParenActivity(data)) {
      this.selectedJobData = { ...this.selectedJobData };
      this.selectedJobData.call = false;
    } else {
      this.selectedJobData = { ...this.selectedJobData };
    }
    // Reset the shared V3 scroll container on tab change. In V2 each sub-tab
    // had its own inner scroll wrapper, so `*ngIf`-swapping tabs produced a
    // fresh element at scrollTop=0. V3 collapsed scroll into the outer
    // `.jc-v3-entity-details-body` which sits OUTSIDE the `*ngIf` swap — so
    // without an explicit reset the viewport stayed where the user left it on
    // the previous tab. `setTimeout(0)` gives Angular a tick to swap children
    // so we reset after the new tab has rendered.
    if (this.designVersion === 'v3') {
      setTimeout(() => {
        const el = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
        if (!el) return;
        el.scrollTo({ top: 0, behavior: 'smooth' });
        // Some tabs (Talent Pool, Marketplace Candidates) render their own inner
        // infinite-scroll container inside the details body, so resetting the
        // body alone doesn't move them — reset those to the top as well.
        el.querySelectorAll('[infiniteScroll], .talent-pool-container')
          .forEach((n) => { (n as HTMLElement).scrollTo({ top: 0, behavior: 'smooth' }); });
      }, 0);
    }
    // Load job profile detail component dynamically when needed
    this.loadJobProfileDetailComponent();
  }

  // Dynamic component loading methods to break circular dependency
  private async loadJobProfileDetailComponent() {
    if (!this.jobProfileDetailContainer) {
      return;
    }

    // Clear previous component instance
    this.jobProfileDetailContainer.clear();
    this.jobProfileDetailComponentRef = null;

    // Only load when jobDetailsTabName is 'job-details'
    if (this.jobDetailsTabName === 'job-details' && this.selectedJobData) {
      try {
        // Dynamic import to break circular dependency
        const { JobProfileDetailComponent } = await import('../../../../components/job-module/job-profile-detail/job-profile-detail.component');

        // Create component instance
        this.jobProfileDetailComponentRef = this.jobProfileDetailContainer.createComponent(JobProfileDetailComponent);

        // Set inputs
        this.jobProfileDetailComponentRef.instance.jobDetails = this.selectedJobData;
        this.jobProfileDetailComponentRef.instance.designVersion = this.designVersion;

        // Subscribe to outputs
        this.jobProfileDetailComponentRef.instance.jobListing.subscribe((event: any) => {
          this.onStatuChange(event);
        });

        this.jobProfileDetailComponentRef.instance.jobReloadFromJobComponent.subscribe((event: any) => {
          this.reloadJobData(event);
        });

        // Trigger change detection
        this.jobProfileDetailComponentRef.changeDetectorRef.detectChanges();
      } catch (error) {
        console.error('Error loading JobProfileDetailComponent:', error);
      }
    }
  }


  tempFilterChanges: any;

  // filter interaction between horizontal and vertical happening here 
  jobFilterData(data: any) {
    this.filterPayLoad.jobsToFilter = null;
    this.singlejobeView =  false;
    this.jobId = null;

    if (data != null && data.from === 'HORIZANTAL') {
      this.tempFilterChanges = data;
      this.clientTypeCheckboxes = data.clientTypeCheckedItems;
      this.statusCheckboxes = data.statusCheckedItems;
      this.jobclasscificationCheckboxes = data.jobClassifications;
      this.jobSource = [...new Set(data.checkedItems)];
      this.businessNetworks = data.businessNetworks;
      this.pickedBusinessNetworks = this.derivePickedNetworks(data.businessNetworkSelectedData);
      this.personalNetworks = data.personalNetworks;
      this.businessCustomers = data.businessCustomers;
      this.publishedByUsers = data.publishedByUsers;
      this.workModeData = data.workMode;
      this.stopscrollFlag = false;
      this.loadCenterSkeleton.next(true);
      this.updateFilterData();
    }
    else if (data != null && data.from === 'VERTICAL') {
      this.tempFilterChanges = data;
      this.clientTypeCheckboxes = data.clientTypeCheckedItems;
      this.statusCheckboxes = data.statusCheckedItems;
      this.jobclasscificationCheckboxes = data.jobClassifications;
      this.jobSource = [];
      this.jobSource = [...new Set(data.checkedItems)];
      this.personalNetworks = data.personalNetworks;
      this.businessNetworks = data.businessNetworks;
      this.pickedBusinessNetworks = this.derivePickedNetworks(data.businessNetworkSelectedData);
      this.businessCustomers = data.businessCustomers;
      this.publishedByUsers = data.publishedByUsers;
      this.workModeData = data.workMode;

    }

  }

  // Derive the deliberate Business Network pick from the raw selection snapshot both
  // filter templates emit (businessNetworkSelectedData: [{ b2bNetworkId, enabled, ... }]).
  // Returns [] when nothing is picked, so the backend only narrows on an explicit choice.
  derivePickedNetworks(selectionSnapshot: any): string[] {
    if (!Array.isArray(selectionSnapshot)) {
      return [];
    }
    return selectionSnapshot
      .filter(x => x && x.enabled === true)
      .map(x => x.b2bNetworkId);
  }

  // updateFilterData() {
  //   this.filterPayLoad.jobClassification = this.jobclasscificationCheckboxes.filter(element => element.selected).map(element => element.label);
  //   this.filterPayLoad.clientType = this.clientTypeCheckboxes.filter(element => element.selected).map(element => element.label);
  //   this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);
  //   this.filterapicall();
  // }
  updateFilterData() {
    const { formData: { source, ...rest } } = this.tempFilterChanges;
    this.filterPayLoad = {
      ...rest,
      searchContent: this.filterPayLoad.searchContent,
      source: source[0],
    }
    this.filterPayLoad.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.stopscrollFlag = false;
    this.filterPayLoad.limit = 20;
    this.filterPayLoad.userId = localStorage.getItem('userId');
    this.filterPayLoad.jobClassification = this.jobclasscificationCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.clientType = this.clientTypeCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.status = this.statusCheckboxes.filter(element => element.selected).map(element => element.label);
    this.filterPayLoad.workMode = Array.isArray(this.workModeData)
    ? this.workModeData.filter(element => element.selected).map(element => element.label)
    : [];
    this.filterPayLoad.personalNetworks = this.personalNetworks;
    this.filterPayLoad.businessNetworks = this.businessNetworks;
    this.filterPayLoad.pickedBusinessNetworks = this.pickedBusinessNetworks;
    this.filterPayLoad.publishedBy = this.publishedByUsers;
    this.filterPayLoad.customers = this.businessCustomers;

    this.filterapicall();
  }


  openFilterSlider() {
    if (!this.isFilterOpen) {
      this.filterChanges = this.tempFilterChanges;
      this.isFilterOpen = true;
      this.jobService.setSliderToggle(true, 'jobs', null,false);
    }
  }

  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'jobs', null,false);
    }
  }



  // chat function

  chatbottom() {
    let seletedItem: any = {};
    // this._socket.ngOnDestroy();
    // this._socket.connections();
    seletedItem.owner = true;
    this.messagemodelflag = true;
    seletedItem.userId = localStorage.getItem('userId');
    this.messageData = [];
    seletedItem.groupType = "JOB";
    seletedItem.messageType = "JOB";
    seletedItem.id = null;
    // Bottom chat: also load direct USER-to-USER contacts (message/new/contact/{userId})
    // and merge them into the list, same as the Home page bottom chat.
    seletedItem.bottomChat = true;
    this.messageData = seletedItem;


  }

  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
    // this._socket.connections_stream();
  }

  streamReloadApicallJobs() {
    let data: any = JSON.parse(localStorage.getItem('jobForm'));
    data.searchAfterKey = null;
    this.filterPayLoad = data;
    this.stopscrollFlag = false
    this.response.next([]);
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.filterPayLoad.searchAfterKey = null;
    this.filterapicall();
  }

  updateFilterPassing() {
    let revokeBtn: filterConfig = new filterConfig(this.jobFilterData);
    revokeBtn.source = this;
    this.filterConfig = revokeBtn;
  }

  /**
   * Calculate total count of active filters by checking actual filter arrays
   * @returns number of active filters
   */
  getActiveFilterCount(): number {
    let totalCount = 0;

    // Check client type filters
    if (this.clientTypeCheckboxes && Array.isArray(this.clientTypeCheckboxes)) {
      totalCount += this.clientTypeCheckboxes.filter(item => item.selected).length;
    }

    // Check status filters
    if (this.statusCheckboxes && Array.isArray(this.statusCheckboxes)) {
      totalCount += this.statusCheckboxes.filter(item => item.selected).length;
    }

    // Check job classification filters
    if (this.jobclasscificationCheckboxes && Array.isArray(this.jobclasscificationCheckboxes)) {
      totalCount += this.jobclasscificationCheckboxes.filter(item => item.selected).length;
    }

    // Check work mode filters
    if (this.workModeData && Array.isArray(this.workModeData)) {
      totalCount += this.workModeData.filter(item => item.selected).length;
    }

    // Check source filters from form (Job Source)
    if (this.jobFilterForm) {
      const formValues = this.jobFilterForm.getRawValue();
      if (formValues.source && Array.isArray(formValues.source)) {
        formValues.source.forEach((sourceGroup: any) => {
          if (sourceGroup) {
            Object.keys(sourceGroup).forEach(key => {
              if (key !== 'All' && sourceGroup[key] === true) {
                totalCount++;
              }
            });
          }
        });
      }

      // Check posted by filters
      if (formValues.postedBy) {
        Object.keys(formValues.postedBy).forEach(key => {
          if (formValues.postedBy[key] === true) {
            totalCount++;
          }
        });
      }

      // Check experience type (if not default)
      if (formValues.experienceType && formValues.experienceType !== 'Any (Years)') {
        totalCount++;
      }

      // Check posted day range (if not default)
      if (formValues.postedDayRange && formValues.postedDayRange !== 'Any (Days)') {
        totalCount++;
      }
    }

    return totalCount;
  }

  // V3 helper methods for detail header
  getCurrency(country: string): string {
    switch (country) {
      case 'US': return 'USD';
      case 'IN': return 'INR';
      case 'CA': return 'CAD';
      case 'AU': return 'AUD';
      default: return 'CUR';
    }
  }

  // CEIPAL jobs carry their own currency from the ATS; only USD/INR/CAD/AUD
  // are supported in the UI, anything else displays as CUR.
  getJobCurrency(job: any): string {
    if (job?.source === 'CEIPAL') {
      const cur = (job?.currency ?? '').toString().trim().toUpperCase();
      return ['USD', 'INR', 'CAD', 'AUD'].indexOf(cur) !== -1 ? cur : 'CUR';
    }
    return this.getCurrency(job?.country);
  }

  getPayType(payType: string): string {
    switch (payType) {
      case 'Hourly': return 'Hr';
      case 'Daily': return 'Day';
      case 'Weekly': return 'Week';
      case 'Monthly': return 'Month';
      case 'Yearly': return 'Year';
      default: return payType || '';
    }
  }

}

